/*
 * @Author: yangyuan
 * @Description:
 * @Date: 2022-04-18 15:45:49
 * @LastEditTime: 2024-02-01 16:51:19
 */
import type { BaseTreeItem } from '@kastjs/runtime-core';
import { IDollyItem, IDollyOptions } from './types';
// import { getAppResourceById } from './apis';
// import { getApp } from 'plugins/micro-app/utils';
// import { innerSystem } from 'plugins/micro-app/utils';

export const createCoreIdWrap = function (intal?: number[]) {
  let coredId = Math.max.apply(null, intal || [0]);
  return function () {
    return ++coredId;
  };
};

// function startWithBaseName(menu: BaseTreeItem[], basenameList: string[]): Boolean {
//   return menu.some(item => {
//     for (let i = 0; i < basenameList.length; i++) {
//       const basename = basenameList[i];
//       return (
//         (item.path.includes(basename) && item.component) ||
//         startWithBaseName(item.children || [], basenameList)
//       );
//     }
//     return false;
//   });
// }

// export const checkBasename = (
//   list: IDollyItem[],
//   menuData: BaseTreeItem[]
// ): boolean => {
//   const basenameList: string[] = [];
//   for (let i = 0; i < list.length; i++) {
//     const item = list[i];
//     if (!basenameList.includes(item.basename)) {
//       basenameList.push(item.basename);
//     } else {
//       console.error(
//         `[Kast error] dollyApp basename should not be repeated，${item.basename} already exists`
//       );
//       return false;
//     }
//   }
//   if (startWithBaseName(menuData, basenameList)) {
//     console.error(
//       `[Kast error] item in menuData should not contain a route start with ${basenameList.toString()}`
//     );
//     return false;
//   }

//   return true;
// };

export const waitDomMount = (selector: string, callback: Function, timeRemain = 10000): void => {
  let dom = document.querySelector(selector);
  if (dom) {
    callback(dom);
  } else {
    if (timeRemain <= 0) {
      console.warn(`[Kast-Warn]: time limit exceeded to load dom element ${selector}`);
      return;
    }
    setTimeout(() => {
      waitDomMount(selector, callback, timeRemain - 10);
    }, 10);
  }
};

function replaceUrl(url: string) {
  try {
    if (url?.includes('cdnfile.corp.kuaishou')) return url;
    const cdn_public_path = (window as any).cdn_public_path;

    let newUrl = url;

    // 去掉协议和 // 的 url
    const urlWithoutProtocol = url?.split('//').pop();
    // 再以 / 分割去掉域名后再拼接回去
    const urlWithoutDomain = urlWithoutProtocol?.split('/').slice(1).join('/');

    if (!urlWithoutDomain) {
      return url;
    }

    if (cdn_public_path.endsWith('/')) {
      newUrl = cdn_public_path + urlWithoutDomain;
    } else {
      newUrl = cdn_public_path + '/' + urlWithoutDomain;
    }

    return newUrl;
  } catch (err) {
    console.error(err, '========= replaceUrl =========');
    return url;
  }
}

export function replaceCdnDomain(data: any[]) {
  if (!(window as any).cdn_public_path) {
    return data;
  }

  try {
    const appList: any[] = [];

    for (const appInfo of data) {
      const jsEntry = appInfo.jsEntry?.filter(Boolean).map(replaceUrl);
      const cssEntry = appInfo.cssEntry?.filter(Boolean).map(replaceUrl);
      const newAppInfo = { ...appInfo, jsEntry, cssEntry };
      appList.push(newAppInfo);
    }

    return appList;
  } catch (err) {
    console.error(err, '========= replaceCdnDomain =========');
    return data;
  }
}

// 获取需要注册的子应用
export async function getChildAppList(menuData: BaseTreeItem[], options?: IDollyOptions) {
  const isPortal = options?.type === 'main' && options?.source === 'portal';
  // 门户走keyconf拉取应用关系
  const paramsData = isPortal ? { source: 'portal' } : { data: menuData };
  const { data } = await options?.axiosInstance.post(
    `/rest/application/relation/runtime`,
    paramsData
  );
  return data;
}

// 将应用关系写入localstorage做兜底
export const writeConfigToLocalstorage = (config: IDollyItem[], appId: number) => {
  const host = window.location.host;
  window.localStorage.setItem(`${host}_${appId}_micro`, JSON.stringify(config));
};

// 读取localstorage兜底应用关系
export const getConfigFromLocalstorage = (appId: number): IDollyItem[] => {
  const host = window.location.host;
  let config = null;
  try {
    const str = window.localStorage.getItem(`${host}_${appId}_micro`) || '[]';
    config = JSON.parse(str);
  } catch (e) {}
  return config;
};

export function appendCssLink(cssEntry: string) {
  if (
    // 防止重复append
    [].slice.call(document.styleSheets).find((style: HTMLLinkElement) => {
      return style.href === cssEntry;
    })
  ) {
    return;
  }
  const link = document.createElement('link');
  link.setAttribute('type', 'text/css');
  link.setAttribute('rel', 'stylesheet');
  link.setAttribute('href', cssEntry);
  return document.head.appendChild(link);
}

export const removeCssLink = (cssEntry: string) => {
  if (!cssEntry) {
    console.warn('removing css, empty css entry in', cssEntry);
    return;
  }
  const link = document.querySelector(`link[href="${cssEntry}"]`);
  if (link) {
    link.remove();
  }
};

export const getStorage = (key: string) => {
  try {
    const value = localStorage.getItem(key);
    if (value === null || value === undefined || value === '') {
      return null;
    }
    return JSON.parse(value);
  } catch (err) {
    return null;
  }
};
